export const PASSWORD_RULES = {
  minLength: 10,
  maxLength: 40,
  minRequired: 2,
};

export const validatePassword = (password) => {
  const errors = [];

  if (password.length < PASSWORD_RULES.minLength)
    errors.push(`At least ${PASSWORD_RULES.minLength} characters`);

  if (password.length > PASSWORD_RULES.maxLength)
    errors.push(`At most ${PASSWORD_RULES.maxLength} characters`);

  const count = (regex) => (password.match(regex) || []).length;

  if (count(/[A-Z]/g) < PASSWORD_RULES.minRequired)
    errors.push(`At least ${PASSWORD_RULES.minRequired} uppercase letters`);

  if (count(/[a-z]/g) < PASSWORD_RULES.minRequired)
    errors.push(`At least ${PASSWORD_RULES.minRequired} lowercase letters`);

  if (count(/[0-9]/g) < PASSWORD_RULES.minRequired)
    errors.push(`At least ${PASSWORD_RULES.minRequired} numbers`);

  if (
    count(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g) < PASSWORD_RULES.minRequired
  )
    errors.push(`At least ${PASSWORD_RULES.minRequired} special characters`);

  return errors;
};
